var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"modal-header\">\n<h3 class=\"modal-title\" translate>Huolto alkamassa</h3>\n</div>\n<div class=\"modal-body\">\n<p translate>\nPalvelussa on alkamassa huolto <strong>{{$ctrl.humanDuration}}</strong> kuluttua. Huomioithan, että huollon aikana sivuston kaikkia toimintoja ei voi käyttää.\n</p>\n</div>\n<div class=\"modal-footer\">\n<normal-button click-action=\"$ctrl.close()\"><span translate>Jatka</span></normal-button>\n</div>\n</div>\n";
var id1="app/common/keepalive/maintenance_reminder.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/keepalive/maintenance_reminder.tpl.html
// module id = 376
// module chunks = 6